import {DomainObject} from 'shared/store';
import {calendarDate} from 'shared/tools';
import { computed, observable, makeObservable } from 'mobx';

class Holiday extends DomainObject {
  name;
  date;
  duration = 'full_day';
  locationIds;
  includedInTimeTracking = true;

  _relations = {
    _dates: ['date']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      date: observable,
      duration: observable,
      locationIds: observable,
      includedInTimeTracking: observable,
      dateView: computed
    });

    this.merge(other);
  }

  get dateView() {
    return calendarDate(this.date);
  }
}

export default Holiday;
